export const layers = {
  cloud: 100000,
  skyscraper: 1300,
  tower: 1200,
  house: 1000,
};
